import { useState, useRef, useEffect } from 'react'; // 新增：引入钩子
import OverviewPorcelain from '../components/OverviewPorcelain';
import img_1 from '../assets/images/app/1.webp';
import img_2 from '../assets/images/exp/2.webp';
import img_3 from '../assets/images/exp/2.webp';
import img_4 from '../assets/images/app/4.webp';
import img_5 from '../assets/images/app/5.webp';
import img_5_1 from '../assets/images/app/5_1.webp';
import img_6 from '../assets/images/app/6.webp';
import img_half_sun from '../assets/images/app/half_sun.webp';
import slide from '/slide.webp';
import gourd from '../assets/images/app/gourd.webp';
import sun from '../assets/images/app/sun.webp';
import video_3 from '../assets/videos/3.mp4';
import video_4 from '../assets/videos/4.mp4';


export default function Appreciation() {
  const [isAnimated, setIsAnimated] = useState(false); // 新增：动画状态
  const parentRef = useRef<HTMLDivElement>(null); // 新增：父节点引用
  const [isInViewport, setIsInViewport] = useState(false);
  const parentGourdRef = useRef<HTMLDivElement>(null); // 新增：父节点引用
  const [isInViewport1, setIsInViewport1] = useState(false);
  const parent5_1Ref = useRef<HTMLDivElement>(null); // 新增：父节点引用

  const [isDragging, setIsDragging] = useState(false);  // 拖动状态
  const [startX, setStartX] = useState<number>(0);             // 鼠标按下时的初始X坐标
  const [offsetX, setOffsetX] = useState<number>(0);           // 当前水平偏移量


  // 鼠标按下时记录初始位置
  const handleMouseDown = (e: React.MouseEvent<HTMLImageElement>) => {
    e.preventDefault(); // 阻止浏览器默认的图片拖动行为
    setIsDragging(true);
    setStartX(e.clientX - offsetX);  // 计算初始位置（考虑已有偏移量）
  };

  // 鼠标移动时更新偏移量（仅在拖动状态下）
  const handleMouseMove = (e: MouseEvent) => {  // 修改参数类型为原生 MouseEvent
    if (isDragging && parentRef.current) {
      // 获取父容器和图片的实时宽度（假设父容器是第二部分的<div>）
      const parentWidth = parentRef.current.getBoundingClientRect().width || 0;
      const slideWidth = parentRef.current.querySelector('img[src$="slide.webp"]')?.getBoundingClientRect().width || 0;
      const minOffset = parentWidth - (parentWidth * 0.5 + slideWidth * 0.43);
      const maxOffset = (parentWidth * 0.3) - (parentWidth * 0.5 - slideWidth * 0.5);

      // 新增：阻尼系数（0.3-0.7之间，值越小阻尼感越强）
      const dampingFactor = 0.5;
      // 计算原始偏移量（鼠标移动量）
      const rawOffset = e.clientX - startX || 0;
      // 应用阻尼：实际偏移量 = 原始偏移量 * 阻尼系数 + 上一次偏移量 * (1 - 阻尼系数)
      const dampedOffset = rawOffset * dampingFactor + offsetX * (1 - dampingFactor);

      // 限制偏移量在[minOffset, maxOffset]之间（边界仍保持硬限制）
      const finalOffset = Math.min(Math.max(dampedOffset, minOffset), maxOffset);
      setOffsetX(finalOffset);
      // console.log('Final Offset', finalOffset, 'px', minOffset, maxOffset, rawOffset, dampedOffset, offsetX, parentWidth, slideWidth);
    }
  };

  // 鼠标松开或离开时结束拖动
  const handleMouseUp = () => {
    setIsDragging(false)
    // console.log('End:', offsetX, 'px');
  };
  const handleMouseLeave = () => setIsDragging(false);
  // 新增：组件挂载时初始化偏移量到最右侧
  useEffect(() => {
    if (parentRef.current) {
      const parentWidth = parentRef.current.getBoundingClientRect().width;
      const slideImg = parentRef.current.querySelector('img[src$="slide.webp"]');
      if (slideImg) {
        const slideWidth = slideImg.getBoundingClientRect().width;
        // 计算最大允许偏移量（与 handleMouseMove 中逻辑一致）
        const maxOffset = (parentWidth * 0.3) - (parentWidth * 0.5 - slideWidth * 0.5);
        setOffsetX(maxOffset); // 初始设置为最大偏移量（最右侧）
      }
    }
  }, []); // 仅在组件挂载时执行
  useEffect(() => {
    if (isDragging) {
      window.addEventListener('mousemove', handleMouseMove);
    }
    if (parentRef.current) {
      // 初始化 Intersection Observer（滚动到父节点 10% 可见时触发）
      const observer = new IntersectionObserver(
        ([entry]) => {
          if (entry.isIntersecting) {
            setIsAnimated(true); // 进入视口时触发动画
            observer.unobserve(entry.target); // 只触发一次
          }
        },
        { threshold: 0.1 }
      );
      observer.observe(parentRef.current);

      // 组件卸载时断开观察者
      return () => {
        observer.disconnect();
        window.removeEventListener('mousemove', handleMouseMove);
      }
    }
  }, [isDragging]);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInViewport(true);
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      }
    );

    if (parentGourdRef.current) {
      observer.observe(parentGourdRef.current);
    }

    return () => observer.disconnect();
  }, []);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInViewport1(true);
        }
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.1
      }
    );

    if (parent5_1Ref.current) {
      observer.observe(parent5_1Ref.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <div className="relative" style={{ overflowX: 'hidden' }}>
      {/* 第一部分 */}
      <div className="relative">
        <img src={img_1} alt="Hero background" className="w-full h-auto" />
        <div className="left-[6%]  bottom-[8%] absolute w-[45%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffffc6] text-[0.7vw] leading-[1.2vw] text-justify">鉴析篇，本节以交互式动态数据可视化图表呈现《历代名瓷图谱》中83件瓷器在工艺、器型、釉色、纹饰、时空分布上的基础信息。首先，探讨了83件瓷器的基本特征与历史背景的核心属性关联：包括以桑基图可视化来探讨瓷器、年代、窑口和器型之间的关联；气泡地图展示了不同时期窑口的兴衰与分布；树图展示了瓷器的时空分布与纹饰工艺之间的关系。其次，通过以下可视化展现了83件瓷器的物理属性与设计规律：雷达图对比了不同器型的尺寸比例特征；环形图和点状图展示了83件瓷器的颜色概览……</span>
            <span className="text-[#ffffffc6] text-[0.7vw] leading-[1vw] text-justify">In this section of the Appreciation and Analysis chapter, interactive dynamic data visualisation charts are used to present basic information on the craftsmanship, vessel types, glaze colours, decorations, and temporal and spatial distribution of the 83 porcelain wares in the Atlas of Famous Porcelains of All Ages. Firstly, the core attribute associations between the basic characteristics of the 83 pieces of porcelain and the historical context are explored: including a Sankey diagram visualisation to explore the associations between porcelain, age, kiln and vessel type; a bubble map showing the rise and fall of kilns and distribution of kilns in different periods; and a tree diagram demonstrating the relationship between spatial and temporal distributions of porcelain and decorative craftsmanship. Secondly, the physical attributes and design patterns of the 83 porcelain wares are shown through the following visualisations: the radar map compares the size scale characteristics of the different vessel types; the ring and dot maps show an overview of the colours of the 83 wares ......</span>
          </div>
        </div>
      </div>
      {/* 第二部分 */}
      <div ref={parentRef} className="relative" style={{ height: 'inherit' }}>  {/* 继承背景图高度 */}
        <img src={img_2} alt="Hero background" className="w-full h-auto" />  {/* 背景图自动高度 */}
        <div className="left-[5vw]  top-[5vw] absolute">
          <span className="text-[#ffffffc6] text-[1.5vw]">滑动查看 Slide to view</span>
        </div>
        <img
          src={img_half_sun}
          className={`h-full absolute bottom-0 ${isAnimated ? 'right-0 opacity-100' : 'right-[-20%] opacity-0'} transition-all duration-3000`}
        />
        <img
          src={slide}
          alt="Hero background"
          className="absolute top-[55%] left-[20%] cursor-pointer "
          style={{
            height: '70%',  /* 保持父容器高度的50% */
            width: 'auto',  /* 保持宽高比 */
            maxWidth: '1000%',  /* 新增：限制最大宽度不超过父容器 */
            objectFit: 'contain',
            userSelect: 'none',
            willChange: 'transform',  // 添加硬件加速
            transform: `translate(-50%, -50%) translateX(${offsetX}px)`
          }}
          onMouseDown={handleMouseDown}
          onMouseUp={handleMouseUp}
          onMouseLeave={handleMouseLeave}
        />
      </div>
      {/* 第三部分 */}
      <div className="relative z-[10]">
        <img src={img_3} alt="Hero background" className="w-full h-auto" />
        <div className="left-[32%] top-[3vw] absolute w-[35%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1.8vw] text-center">《历代名瓷图谱》83件瓷器概览</span>
            <span className="text-[#ffffff] text-[1.2vw]  text-center">Overview of the 83 Porcelain Pieces in "Illustrated Catalog of Ceramics Through the Dynasties"</span>
          </div>
        </div>
        <div className="right-[8%] top-[10%] absolute w-[35%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1.2vw] text-right">点击查看瓷器详情</span>
            <span className="text-[#ffffff] text-[1vw]  text-right">Click to view porcelain details</span>
          </div>
        </div>
        <div className="left-[15%]  bottom-[5vw] absolute w-[70%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[0.8vw] text-center">您可点击每一件瓷器查看它的详细信息，其中包括色彩占比、纹饰描述、制作工艺、窑口及地理位置、流传线、功能及器型、评价价值、独特性量化分析各维度得分以及《图谱》原文。</span>
            <span className="text-[#ffffff] text-[0.8vw] text-center">You can click on each porcelain piece to view its detailed information, including color proportion, decoration description, manufacturing techniques, kiln and geographical location, provenance, function and vessel type, evaluation value, quantitative analysis of uniqueness, and the original text from the Illustrated Catalog of Ceramics Through the Dynasties.</span>
          </div>
        </div>
        <div className='z-[999]'>
          <OverviewPorcelain type={1} />
        </div>

      </div>
      {/* 第四部分 */}
      <div ref={parentGourdRef} className="relative parent-section">
        <img src={img_4} alt="Hero background" className="w-full h-auto" />
        <img
          src={gourd}
          className="h-[75%] absolute transition-all duration-3000"
          style={{
            right: isInViewport ? '-10.6%' : '-20%',
            top: isInViewport ? '-31%' : '-50%',
            opacity: isInViewport ? 1 : 0
          }}
        />
        <div className="left-[3%] top-[5%] absolute w-[29%]">
          <div className="flex flex-col items-left">
            <span className="text-[#000000] text-[1.5vw] text-left">核心属性关联—瓷器的基本特征与历史背景</span>
            <span className="text-[#000000] text-[1.2vw] leading-[1.5vw] text-left">Core Attribute Correlation - Basic Characteristics and Historical Background of Porcelain</span>
          </div>
        </div>
        <span className="left-[6%] top-[16%] absolute text-[#000000] text-[1.3vw] text-left">瓷器名称<span className="text-[#000000] text-[1.2vw]"> Porcelain Name</span></span>
        <span className="left-[33%] top-[16%] absolute text-[#000000] text-[1.3vw] text-left">年代<span className="text-[#000000] text-[1.2vw]"> Period</span></span>
        <span className="left-[55%] top-[16%] absolute text-[#000000] text-[1.3vw] text-left">窑口<span className="text-[#000000] text-[1.2vw]"> Kiln Site</span></span>
        <span className="left-[76%] top-[16%] absolute text-[#000000] text-[1.3vw] text-left">器型<span className="text-[#000000] text-[1.2vw]"> Vessel Types</span></span>
        <div className="left-[55%] bottom-[18%] absolute w-[38%]">
          <div className="flex flex-col items-left">
            <span className="text-[#000000] text-[1.5vw] leading-[1.5vw] text-left">桑基图</span>
            <span className="text-[#000000] text-[1.2vw] leading-[1.5vw] text-left">Sanquito</span>
            <span className="text-[#000000] text-[1vw] leading-[1.5vw] mt-[1vw] text-justify">桑基图可视化，以流体力学的视觉逻辑，呈现瓷器、年代、窑口与器型的多维关联，您可以随意点击滑动可视化图表查看详细信息。</span>
            <span className="text-[#000000] text-[1vw] leading-[1.5vw] text-justify">Sankey Diagram Visualization: Utilizing the visual logic of fluid dynamics, this interactive visualization reveals the multi-dimensional relationships among porcelain, historical periods, kilns, and vessel types. You can freely click and swipe the chart to explore detailed information.</span>
          </div>
        </div>
        {/* 桑基图 */}
        <div className="left-[6%] top-[14.7%] absolute w-[35%] h-[70%]">
          <iframe
            src='https://flo.uri.sh/visualisation/23654116/embed'
            title='Interactive or visual content'
            className='flourish-embed-iframe'
            style={{ width: '100%', height: '100%' }}
            sandbox='allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'>
          </iframe>
        </div>
        <div className="left-[34%] top-[14%] absolute w-[25%] h-[40%]">
          <iframe
            src='https://flo.uri.sh/visualisation/23654175/embed'
            title='Interactive or visual content'
            className='flourish-embed-iframe'
            style={{ width: '100%', height: '100%' }}
            sandbox='allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'>
          </iframe>
        </div>
        <div className="left-[58%] top-[15%] absolute w-[27%] h-[50%]">
          <iframe
            src='https://flo.uri.sh/visualisation/23654193/embed'
            title='Interactive or visual content'
            className='flourish-embed-iframe'
            style={{ width: '100%', height: '100%' }}
            sandbox='allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'>
          </iframe>
        </div>
      </div>
      {/* 第五部分 */}
      <div ref={parent5_1Ref} className="relative">
        <video
          src={video_3}
          className="w-full h-auto"  // 铺满容器宽度，高度自适应
          autoPlay                  // 自动播放（注意：部分浏览器需要配合 muted）
          loop                      // 循环播放
          muted                     // 静音（避免自动播放被浏览器阻止）
          playsInline               // iOS 设备内联播放（非全屏）
          controls={false}          // 隐藏控制条（根据需求可改为 true 显示）
        />
        <img
          src={img_5_1}
          className="h-[90%] absolute transition-all duration-3000 z-[1]"
          style={{
            left: isInViewport1 ? '-23%' : '-50%',
            bottom: isInViewport1 ? '-65%' : '10%',
            opacity: isInViewport1 ? 1 : 0
          }}
        />
        <div className="left-[4%] top-[8%] absolute w-[16%] h-[21%] bg-[#000]"></div>
        <div className="left-[5%] top-[9%] absolute w-[20%] h-[21%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1.8vw] leading-[2.2vw] text-left">展示不同时期</span>
            <span className="text-[#ffffff] text-[1.8vw] leading-[2.2vw] text-left">窑口的兴衰与分布</span>
            <span className="text-[#ffffff] text-[1.3vw] leading-[2vw] text-left" style={{ letterSpacing: '0.1vw' }}>Showing the rise and fall of kilns in different periods and their distribution</span>
          </div>
        </div>
        <div className="left-[5%] top-[32%] absolute w-[20%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1.3vw] leading-[1.8vw] text-left">气泡地图</span>
            <span className="text-[#ffffff] text-[1.2vw] leading-[1.8vw] text-left" style={{ letterSpacing: '0.1vw' }}>Bubble Map</span>
          </div>
        </div>
        <div className="left-[5%] top-[41%] absolute w-[13%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1vw] leading-[1.8vw] text-justify">气泡地图通过地理分布与气泡大小，直观展示不同时期窑口的兴衰轨迹。</span>
            <span className="text-[#ffffff] text-[0.8vw] leading-[1.8vw] text-justify">Bubble Map Visualization: The map uses geographical distribution and bubble size to visually demonstrate the rise and decline of kiln sites across different historical periods.</span>
          </div>
        </div>
      </div>
      {/* 第六部分 */}
      <div className="relative">
        <img src={img_5} alt="Hero background" className="w-full h-auto" />
        <div className="left-[5%] bottom-[45%] absolute w-[12%] z-[99]">
          <div className="flex flex-col items-left">
            <span className="text-[#000000] text-[1.5vw] leading-[1.5vw] text-left">关联年代与纹饰</span>
            <span className="text-[#000000] text-[1.2vw] leading-[1.5vw] text-left">Associated Dating and Decorations</span>
          </div>
        </div>
        <div className="left-[5%] bottom-[15%] absolute w-[35%]">
          <div className="flex flex-col items-left">
            <span className="text-[#000000] text-[1.5vw] leading-[1.5vw] text-left">树图</span>
            <span className="text-[#000000] text-[1.2vw] leading-[1.5vw] text-left">Tree Map</span>
            <span className="text-[#1b1515] text-[1vw] leading-[1.5vw] mt-[1vw] text-left">树图，以嵌套矩形层级，关联瓷器时空分布与纹饰工艺的演化逻辑。</span>
            <span className="text-[#000000] text-[1vw] leading-[1.5vw] text-left">Tree Map: Utilizing nested rectangular hierarchies to link the spatial and temporal distribution of porcelain with the evolutionary logic of decorative patterns and craftsmanship.</span>
          </div>
        </div>
        <div className="left-[38%] top-[4%] absolute w-[50%] h-[85%]">
          <iframe
            src='https://flo.uri.sh/visualisation/23654227/embed'
            title='Interactive or visual content'
            className='flourish-embed-iframe'
            style={{ width: '100%', height: '100%' }}
            sandbox='allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'>
          </iframe>
        </div>

      </div>
      {/* 第七部分 */}
      <div className="relative">
        <img src={img_2} alt="Hero background" className="w-full h-auto" />
        <img
          src={sun}
          className="animate-sun absolute w-[60%] h-auto bottom-[-55%] right-[-30%] z-[1]"
          style={{
            transform: 'rotate(0deg)',
            transition: 'transform 0.01s' // 解决动画重置问题
          }}
        />
        <div className="left-[5%] top-[10%] absolute w-[50%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1.8vw] leading-[1.8vw] text-left">物理特征分析—瓷器的物理属性与设计规律</span>
            <span className="text-[#ffffff] text-[1.3vw] leading-[1.8vw] text-left mt-[0.5vw]" style={{ letterSpacing: '0.1vw' }}>Physical Characterisation - Physical Properties of Porcelain and Design Laws</span>
          </div>
        </div>
        <div className="right-[6%] top-[10%] absolute w-[19%]">
          <div className="flex flex-col">
            <span className="text-[#ffffff] text-[1.8vw] leading-[2vw] text-right">雷达图对比不同器型的尺寸比例特征</span>
            <span className="text-[#ffffff] text-[1.3vw] leading-[2vw] text-right">Radar chart comparing the dimensional scale characteristics of different vessel types</span>
          </div>
        </div>
        <div className="right-[6%] top-[29%] absolute w-[17%]">
          <div className="flex flex-col">
            <span className="text-[#ffffff] text-[0.8vw] leading-[1.5vw] mt-[1vw] text-justify">雷达图选取高宽比、体积等级等参数，对比了23种不同器型的尺寸比例特征，您可以点击查看某一种单独器型的尺寸比例特征，同时也可以切换查看两种或几种不同器型的尺寸特征对比。</span>
            <span className="text-[#ffffff] text-[0.8vw] leading-[1.5vw] mt-[2vh] text-justify">Radar Chart: Parameters like aspect ratio and volume classification highlight the dimensional proportion traits of 23 vessel types. You can click to explore individual vessel types or toggle between comparisons of multiple vessel types.</span>
          </div>
        </div>
        <div className="left-[5%] top-[18%] absolute w-[66%] h-[80%]">
          <iframe
            src='https://flo.uri.sh/visualisation/23654250/embed'
            title='Interactive or visual content'
            className='flourish-embed-iframe'
            style={{ width: '100%', height: '100%' }}
            sandbox='allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'>
          </iframe>
        </div>

      </div>
      {/* 第八部分 */}
      <div className="relative">
        <img src={img_2} alt="Hero background" className="w-full h-auto" />
        <div>
          <div className='z-[999]'>
            <OverviewPorcelain type={2} />
          </div>
          <div className="left-[7%] bottom-[10%] absolute w-[50%]">
            <div className="flex flex-col items-left">
              <span className="text-[#ffffff] text-[1.8vw] leading-[1.8vw] text-left">点击放大查看详情</span>
              <span className="text-[#ffffff] text-[1.5vw] leading-[2.5vw] text-left">Click to zoom in for more details</span>
            </div>
          </div>
          <div className="right-[6%] bottom-[45%] absolute w-[22%]">
            <div className="flex flex-col items-left">
              <span className="text-[#ffffff] text-[1.5vw] leading-[1.8vw] text-right">项元汴收藏瓷器的颜色概览</span>
              <span className="text-[#ffffff] text-[1.2vw] leading-[1.8vw] text-right">Overview of Colours in Xiang Yuanbian's Porcelain Collection</span>
            </div>
          </div>
          <div className="right-[6%] bottom-[10%] absolute w-[20%]">
            <div className="flex flex-col items-left">
              <span className="text-[#ffffff] text-[1vw] leading-[1.8vw] text-right">对于瓷器的颜色分析，首先，我们提取了每件瓷器的颜色色卡并制作成可视化概览图，您可以点击查看每一件瓷器的详细信息。</span>
              <span className="text-[#ffffff] text-[0.8vw] mt-[2vh] leading-[1.8vw] text-right">Color Analysis of Porcelain: For the color analysis, we first extracted the color palettes of each porcelain piece and compiled them into a visual overview. You can click to view detailed information for each individual porcelain item.</span>
            </div>
          </div>
        </div>
        {/* <div>
          <div className="left-[5%] top-[10%] absolute w-[50%]">
            <div className="flex flex-col items-left">
              <span className="text-[#ffffff] text-[1.8vw] leading-[1.8vw] text-left">返回</span>
              <span className="text-[#ffffff] text-[1.5vw] leading-[1.8vw] text-left">Back</span>
            </div>
          </div>
        </div> */}
      </div>
      {/* 第九部分 */}
      <div className="relative">
        <img src={img_6} alt="Hero background" className="w-full h-auto" />
        <div className="right-[10%] top-[18%] absolute w-[33%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1.5vw] leading-[1.8vw] text-right">根据《历代名瓷图谱》图片提取颜色进行汇总</span>
            <span className="text-[#ffffff] text-[1.3vw] leading-[1.8vw] mt-[0.6vw] text-right">Extract and Aggregate Colors Based on Images from Documentary Sources</span>
          </div>
        </div>
        <div className="right-[10%] top-[50%] absolute w-[20%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1vw] leading-[1.8vw] text-right">环形色彩分布图提取了《历代名瓷图谱》中的瓷器图片色彩，展示了图谱中83件瓷器的颜色类别和占比，构成瓷器的视觉色谱库。</span>
            <span className="text-[#ffffff] text-[0.8vw] mt-[2vh] leading-[1.8vw] text-right">Circular Color Distribution: This visualization extracts the color palettes from porcelain images in Illustrated Catalog of Ceramics Through the Dynasties, displaying the color categories and proportions of the 83 porcelain pieces in the catalog, forming a visual color spectrum library for porcelain.</span>
          </div>
        </div>
      </div>
      {/* 第十部分 */}
      <div className="relative">
        <img src={img_2} alt="Hero background" className="w-full h-auto" />
        <div className="left-[32%] top-[5%] absolute w-[35%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1.2vw] leading-[1.8vw] text-center">根据《图谱》对于色彩的文字描述结合古代色谱进行颜色整理</span>
            <span className="text-[#ffffff] text-[1.2vw] leading-[1.8vw] text-center">Colour sorting based on textual descriptions of colours in books combined with ancient chromatograms</span>
          </div>
        </div>
        <div className="left-[8%] bottom-[8%] absolute w-[80%]">
          <div className="flex flex-col items-left">
            <span className="text-[#ffffff] text-[1vw] leading-[1.8vw] text-center">环形色彩分布图和点状色彩图根据《历代名瓷图谱》中对瓷器色彩的文字记载，结合古代色谱进行瓷器颜色整理，展示了83件瓷器的真实颜色类别和占比，构成瓷器的视觉色谱库。</span>
            <span className="text-[#ffffff] text-[0.8vw] leading-[1.8vw] text-center">Circular and Dot Color Visualizations: Drawing from textual color descriptions in Illustrated Catalog of Ceramics Through the Dynasties and ancient color references,</span>
            <span className="text-[#ffffff] text-[0.8vw] leading-[1.2vw] text-center">these charts systematically present the color categories and proportions of the 83 porcelain pieces, creating a visual color spectrum database for porcelain.</span>
          </div>
        </div>
        <div className="left-[5%] top-[18%] absolute w-[40%] h-[60%]">
          <iframe
            src='https://flo.uri.sh/visualisation/23654278/embed'
            title='Interactive or visual content'
            className='flourish-embed-iframe'
            style={{ width: '100%', height: '100%' }}
            sandbox='allow-same-origin allow-forms allow-scripts allow-downloads allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'>
          </iframe>
        </div>
        <div className='right-[10%] top-[28%] absolute w-[40%] h-[50%]'>
          <video
            src={video_4}
            className="w-full h-auto"  // 铺满容器宽度，高度自适应
            autoPlay                  // 自动播放（注意：部分浏览器需要配合 muted）
            loop                      // 循环播放
            muted                     // 静音（避免自动播放被浏览器阻止）
            playsInline               // iOS 设备内联播放（非全屏）
            controls={false}          // 隐藏控制条（根据需求可改为 true 显示）
          />
        </div>
      </div>
    </div>
  )
}